<template>

    <a-row class="mt4">

        <div>
            <div style="display: inline-block; width: 100px;">
                <a-col :span="12">
                    <a-button type="danger"
                              @click="orderSearchStepActionDelete">
                        <a-icon type="close-circle"/>
                    </a-button>
                </a-col>
                <a-col :span="12">
                    <a-button  disabled class="ml4">
                        S.{{rowIndex}}
                    </a-button>
                </a-col>
            </div>
            <div style="display: inline-block; width: calc(100% - 100px);" >
                <!--action-->
                <div class="ml10">
                    <a-col :span="4">
                        <div class="ml4">
                            <a-select show-search
                                      optionFilterProp="label"
                                      @change="actionChange"
                                      v-model="orderSearchAction"
                            >
                                <a-select-option :label="item.value" :value="item.value" v-for="item in orderSearchActionSettingRowActionItems">{{item.value}}</a-select-option>
                            </a-select>
                        </div>
                    </a-col>



                    <!--type column-->
                    <a-col :span="6">
                        <div class="ml4">
                            <a-select show-search
                                      v-model="orderSearchTargetField"
                                      @change="targetFieldChange"
                                      >
                                <a-select-option :label="item" :value="item" v-for="item in targetFieldItems">{{item}}</a-select-option>
                            </a-select>
                        </div>

                    </a-col>


                </div>


            </div>
        </div>


    </a-row>


</template>
<script>
    export default {
        props:['orderSearchActionSettingsItem','index', 'orderSearchActionSettingRowActionItems', 'targetFieldItems'],
        data() {
            return {
                rowIndex: this.index + 1,
                orderSearchAction:this.orderSearchActionSettingsItem.action,
                orderSearchTargetField:this.orderSearchActionSettingsItem.value,
            }
        },
        methods: {
            orderSearchStepActionDelete() {
                this.$emit('orderSearchStepActionDelete',this.index)
            },
            actionChange() {
                this.$emit('orderSearActionChange',this.index,this.orderSearchAction)
            },
            targetFieldChange() {
                this.$emit('orderSearchTargetFieldChange',this.index,this.orderSearchTargetField)
            }

        }

    };
</script>